import Component from '@bythepixel/component-loader';
import { eventThrottle } from '@Core/utility';
import GlideSlider from '../../base';

const desktopBreakpoint = 991;

// Refer to https://glidejs.com/docs/options/
const glideOptions = {
  type: 'slider',
  startAt: 0,
  perView: 1,
  rewind: false,
  breakpoints: {
    990: {
      type: 'carousel',
    },
  },
};

const selectors = {
  slideSelector: '[data-logo-slider-slide]',
  leftArrowSelector: '[data-logo-slider-arrow-left]',
  rightArrowSelector: '[data-logo-slider-arrow-right]',
  slideIndicatorSelector: '[data-corporate-logo-slider-indicator]',
  slideIndicatorActiveClass: 'glide__bullet--active',
};

export default class SectionCorporateLogoSlider extends Component {
  static selector = '[data-comp-corporate-logo-slider]';

  constructor(containerEl) {
    super(containerEl);
    this.slider = new GlideSlider(containerEl, glideOptions, selectors);
    this.sliderGlideInstance = this.slider.getGlideSlider();

    // Run these events after mounting the slide
    // And after transitioning between two slides
    this.sliderGlideInstance.on(['mount.after', 'run.after'], () => {
      const slideWidth = this.slider.getSliderWidth();

      this.slider.adjustSlideWidth(slideWidth);
      this.slider.handleArrowButtonVisibility();
    });

    // Run this event before transitioning the slide
    this.sliderGlideInstance.on('run', () => {
      this.slider.handleSlideIndicatorActiveState();
    });

    this.sliderGlideInstance.mount();

    window.addEventListener('resize', eventThrottle(() => this.updateCorporateLogoSliderBetweenBreakpoints(desktopBreakpoint), 100));
  }

  /*
   * Updates corporate logo slider between breakpoints
   * @return {void}
   */
  updateCorporateLogoSliderBetweenBreakpoints(breakpoint) {
    if (window.matchMedia(`(min-width: ${breakpoint}px)`).matches) {
      this.sliderGlideInstance.update({
        type: 'slider',
      });
    } else {
      this.sliderGlideInstance.update({
        type: 'carousel',
      });
    }
  }
}
